export const QuizRubricType = Object.freeze({ HOLISTIC: 'holistic', QUESTION: 'question' });
export const QuizQuestionMode = Object.freeze({ INTERDEPENDENT: 'interdependent', STANDALONE: 'standalone' });
